const PUBLIC_URL = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const SERVICE_WORKER_URL = `${PUBLIC_URL}/service-worker.js`;

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SERVICE_WORKER_URL).catch(() => {
      // Silent failure is acceptable for this installable shell.
    });
  });
};

export const clearClinicianServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => undefined);

    if ('caches' in window) {
      caches
        .keys()
        .then((cacheNames) => Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName))))
        .catch(() => undefined);
    }
  });
};

export const registerClinicianServiceWorker = clearClinicianServiceWorker;
